import { ProviderIcon } from "@/components/ui/ProviderIcon";
import * as shared from "@/styles/shared";
import type { EntryRowProps } from "@/types/ui";
import { PaymentResultStatus } from "@shared/types/payment";
import { formatCurrency } from "@shared/utils";
import { CheckCircle2, XCircle } from "lucide-react";
import * as styles from "./EntryRow.styles";
import * as paymentStyles from "./Payment.styles";

const EntryRow = ({ entry }: EntryRowProps) => (
  <div className={styles.entryContainer}>
    <div className={styles.entryContent}>
      <div className={shared.flexTruncate}>
        <span className="font-medium">{entry.addressName}</span>
        <span className={styles.slashSeparator}>/</span>
        <ProviderIcon provider={entry.providerName} title={entry.providerName} />
      </div>
      <span className={paymentStyles.fontMonoWithMr3}>{formatCurrency(entry.amount)}</span>
      {entry.success === PaymentResultStatus.SUCCESS ? (
        <CheckCircle2 className={paymentStyles.successIconSmall} />
      ) : (
        <XCircle className={paymentStyles.errorIconSmall} />
      )}
    </div>
  </div>
);

export { EntryRow };
